import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { Container } from "@/components/General/Grid/container.component";

type BlockSectionProps = {
    className?: string;
    title: string | ReactNode;
    children: ReactNode;
    iconClass?: string;
};

const BlockSection = ({
    title,
    children,
    iconClass,
    className
}: BlockSectionProps) => {
    return (
        <Container
            as="section"
            className={cn(
                "tw:bg-primary tw:p-6 tw:mb-6 tw:relative tw:text-white tw:text-center tw:flex tw:flex-col tw:items-center",
                className
            )}
        >
            {iconClass && <i className={iconClass} />}
            <h4>{title}</h4>
            {children}
        </Container>
    );
};

export { BlockSection };
